module.exports = __webpack_public_path__ + "media/images/top/photo_sample-4ef07cdf5618486b2d26a395078e0457.jpg";